module.exports = __webpack_public_path__ + "img/herb-sage-350x184.f51d1d8a.jpg";